export const getSinglePost = async (id, token) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch('https://makegayfriends.com/api/v1/statuses/'+id, { headers });
    const data = await response.json();
    return data
}

export const getMultiPost = async ({ids, token}) => {
    console.log(ids)
    const headers = { 'Authorization': 'Bearer '+token }
    const statusIds = ['112862007667034996', '112854411777751641']
      // Create URLSearchParams object
  const params = new URLSearchParams();
  statusIds.forEach(id => params.append('id[]', id));
  console.log('https://makegayfriends.com/api/v1/statuses?'+params.toString())
    const response = await fetch('https://makegayfriends.com/api/v1/statuses?'+params.toString(), { headers });
    console.log(response)
    const data = await response.json();
    return data
}

export const reblogSinglePost = async ({id, token, reblog}) => {
    const headers = { 'Authorization': 'Bearer '+token }
    let fetch_url = reblog ? 'https://makegayfriends.com/api/v1/statuses/'+id+'/reblog' : 'https://makegayfriends.com/api/v1/statuses/'+id+'/unreblog'
    const response = await fetch(fetch_url, { method:"POST", headers });
    const data = await response.json();
    return data
}

export const favouriteSinglePost = async ({id, token, favourite}) => {
    const headers = { 'Authorization': 'Bearer '+token }
    let fetch_url = favourite ? 'https://makegayfriends.com/api/v1/statuses/'+id+'/favourite' : 'https://makegayfriends.com/api/v1/statuses/'+id+'/unfavourite'
    const response = await fetch(fetch_url, { method:"POST", headers });
    const data = await response.json();
    return data
}

export const deleteSinglePost = async ({id, token}) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch('https://makegayfriends.com/api/v1/statuses/'+id, { method:"DELETE", headers });
    const data = await response.json();
    return data
}

export const uploadMedia = async ({image, token}) => {
    let formData = new FormData()
    formData.append('file', image);
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch('https://makegayfriends.com/api/v2/media', { method:"POST", headers, body:formData });
    const data = await response.json();
    return data
}

export const deletedMedia = async ({media_id, token}) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch('https://makegayfriends.com/api/v1/media/'+media_id, { method:"DELETE", headers });
    const data = await response.json();
    return data
}

const getMediaAttachment = async (media_id, token) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch('https://makegayfriends.com/api/v1/media/'+media_id, { headers });
    const data = await response.json();
    return data
}

// Mastodon prunes media attachments that are never attached to a published status,
// which is why profile gallery photos would eventually 404 after upload. Wrapping
// every photo in its own public, otherwise-empty post keeps the media attached
// (and therefore alive) permanently.
export const uploadProfilePhoto = async ({image, token}) => {
    let media = await uploadMedia({image, token})

    // Images are usually processed synchronously, but Mastodon can still return
    // before it's ready (no url yet) — poll briefly rather than posting a broken url.
    let attempts = 0
    while (media?.id && !media?.url && attempts < 10) {
        await new Promise(resolve => setTimeout(resolve, 1000))
        media = await getMediaAttachment(media.id, token)
        attempts++
    }

    if (!media?.id || !media?.url) {
        return media
    }

    const response = await fetch('https://makegayfriends.com/api/v1/statuses', {
        method: "POST",
        headers: { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: '', visibility: 'public', media_ids: [media.id] }),
    })
    const post = await response.json()

    return { id: media.id, img: media.url, status_id: post?.id }
}

// Counterpart to uploadProfilePhoto — deletes the wrapping post (which takes the
// attached media with it). Legacy photos uploaded before this wrapping existed have
// no status_id, so those fall back to deleting the bare media attachment directly.
export const deleteProfilePhoto = async ({status_id, media_id, token}) => {
    if (status_id) {
        return await deleteSinglePost({id: status_id, token})
    }
    return await deletedMedia({media_id, token})
}